import React from 'react';
import {makeStyles} from '@mui/styles';
import {useGoogleLogin} from '@react-oauth/google';
import { FcGoogle } from "react-icons/fc";

const useStyles = makeStyles(() => ({
	button: {
		display: 'inline-flex',
		alignItems: 'center',
		backgroundColor: '#4285F4',
		padding: '4px',
		cursor: 'pointer',
		transition: 'all ease 0.3s',
		border: 'none',
		'&:hover': {
			backgroundColor: '#6199F4',
		},
	},
	icon: {
		backgroundColor: '#fff',
		width: '40px',
		flex: '0 0 40px',
		height: '40px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	text: {
		color: '#fff',
		display: 'inline-flex',
		justifyContent: "center",
		width: "100%",
		padding: '0px 17px',
	}
}));

const GoogleLogin = ({children, width}) => {
	const classes = useStyles();

	const login = useGoogleLogin({
		flow: 'auth-code',
		onSuccess: async (codeResponse) => {
			console.log(codeResponse);
			const tokens = await axios.post(
				'http://localhost:3001/auth/google', {
					code: codeResponse.code,
				});

			console.log(tokens);
		},
		onError: errorResponse => console.log(errorResponse),
	});
	
	return(
		<button onClick={() => login()}
			style={{width: width ? width : ''}}
			className={classes.button}
			type="button"
		>
			<span className={classes.icon}><FcGoogle fontSize={20}/></span>
			<span className={classes.text}>{children}</span>
		</button>
	);
};

export default GoogleLogin;

// const googleId = "826763850002-fnamjgakaclbi20f1sbndsr8lp1noarp";

// const responseGoogle = (response) => {
// 	console.log(response);
// }

// <GoogleLoginButton
// 	clientId={`${googleId}.apps.googleusercontent.com`}
// 	render={renderProps => (
// 		// <button onClick={renderProps.onClick} style={customStyle}>Continue with Google</button>
// 		<button style={{width: width ? width : ''}} onClick={renderProps.onClick} className={classes.button}>
// 			<span className={classes.icon}><FcGoogle fontSize={20}/></span>
// 			<span className={classes.text}>{children}</span>
// 		</button>
// 	)}
// 	buttonText="Login"
// 	onSuccess={responseGoogle}
// 	onFailure={responseGoogle}
// />